







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export class About extends Vue {
  @Prop({ default: null }) message: string;
}
export default About;
